import React, { createContext, useContext, useState, useEffect } from "react";
import { Language } from "../i18n/languages";
import { getTranslation, TranslationNamespace } from "../i18n";

interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (namespace: TranslationNamespace, path: string) => string;
}

const LanguageContext = createContext<LanguageContextType | undefined>(
  undefined,
);

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [language, setLanguage] = useState<Language>(() => {
    const saved = localStorage.getItem("preferred-language") as Language;
    return saved || "es";
  });

  const t = (namespace: TranslationNamespace, path: string): string => {
    return getTranslation(language, namespace, path);
  };

  useEffect(() => {
    localStorage.setItem("preferred-language", language);
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};
